import { Badge } from '@/components/ui';
import { useTranslation } from 'react-i18next';
import type { SubscriptionStatus } from '@/types/admin-subscription';

function getVariant(status: SubscriptionStatus) {
  switch (status) {
    case 'active':
      return 'success';
    case 'pending_termination':
      return 'warning';
    case 'terminated':
      return 'outline';
    case 'cancelled':
      return 'destructive';
    default:
      return 'secondary';
  }
}

export function SubscriptionStatusBadge({ status }: { status: SubscriptionStatus }) {
  const { t } = useTranslation('subscriptions');
  return <Badge variant={getVariant(status)}>{t(`statuses.${status}`)}</Badge>;
}
